import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Auth from "./layouts/auth";
import Public from "./layouts/public";
import Company from "./layouts/company";
import User from "./layouts/user";
import ScrollToTop from "./Components/Scroll/ScrollTop";

function App() {
  return (
    <div className="font-nunito">
      <Routes>
        <Route path="/*" element={<Public />} />
        {/* <Route path="/company/*" element={<Company />} />
        <Route path="/user/*" element={<User />} />
        <Route path="/auth/*" element={<Auth />} /> */}
        <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
      </Routes>
    </div>
  );
}

export default App;
